import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=a9d295a6&scoped=true&"
import script from "./GroupForm.vue?vue&type=script&lang=js&"
export * from "./GroupForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupForm.vue?vue&type=style&index=0&id=a9d295a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d295a6",
  null
  
)

export default component.exports